import React from 'react';
import { motion } from 'framer-motion';

export const LoadingOverlay = ({ message = "Generating..." }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center"
      data-testid="loading-overlay"
    >
      <motion.img
        src="https://static.prod-images.emergentagent.com/jobs/00c06bdf-12dd-49a7-93a8-5762a0039cbc/images/1ed93a159484c5923e9ad2ca98519abdc0b7961e7509b90ec196406a00ba1726.png"
        alt="AI Magic"
        className="w-32 h-32 mb-6"
        animate={{
          y: [0, -10, 0],
          rotate: [0, 5, -5, 0]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <h2 className="text-2xl font-bold text-[#128C7E] mb-2" data-testid="loading-message">
        {message}
      </h2>
      <p className="text-[#667781] text-center px-6">
        AI is analyzing your product and creating the perfect listing
      </p>
    </motion.div>
  );
};
